/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商品管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true"  ref="formInline" :model="formInline"  class="user-search">
      <el-form-item label="用户UID">
        <el-input size="small" clearable v-model="formInline.accountId" placeholder="请输入用户UID"></el-input>
      </el-form-item>
     
      <el-form-item label="手机号码">
        <el-input size="small" clearable  v-model="formInline.phone" placeholder="输入手机号码"></el-input>
      </el-form-item>
      <el-form-item label="昵称">
        <el-input size="small" clearable v-model="formInline.nickName" placeholder="请输入昵称"></el-input>
      </el-form-item>
      
      <el-form-item label="性别">
    <el-select v-model="formInline.sex" placeholder="不限">
      <el-option label="男" value="1"></el-option>
      <el-option label="女" value="2"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="婚姻状况">
    <el-select v-model="formInline.maritalStatus" placeholder="不限">
      <el-option label="未婚" value="1"></el-option>
      <el-option label="离异" value="2"></el-option>
      <el-option label="丧偶" value="3"></el-option>
    </el-select>
  </el-form-item>
  <!-- <el-form-item label="年龄">
    <el-col :span="5">
      <el-input size="small" clearable  v-model="formInline.beginAge" placeholder="不限"></el-input>
    </el-col>
    <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp; -</el-col>
    <el-col :span="5">
      <el-input size="small" clearable  v-model="formInline.endAge" placeholder="不限"></el-input>
    </el-col>
  </el-form-item> -->
  <el-form-item label="学历">
    <el-select v-model="formInline.education" placeholder="请选择">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
  </el-form-item>


  <el-form-item label="版本号">
        <el-input size="small" clearable v-model="formInline.version" placeholder="输入版本号"></el-input>
      </el-form-item>
      <el-form-item label="注册类型">
    <el-select v-model="formInline.registerType" placeholder="不限">
      <el-option label="预注册" value="1"></el-option>
      <el-option label="完成注册" value="2"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="昵称审核">
    <el-select v-model="formInline.nickNameStatus" placeholder="不限">
      <el-option label="待审核" value="1"></el-option>
      <el-option label="通过" value="2"></el-option>
      <el-option label="不通过" value="3"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="头像审核">
    <el-select v-model="formInline.headIconStatus" placeholder="不限">
      <el-option label="待审核" value="1"></el-option>
      <el-option label="通过" value="2"></el-option>
      <el-option label="不通过" value="3"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="是否测试号">
    <el-select v-model="formInline.isTestAccount" placeholder="不限">
      <el-option label="是" value="1"></el-option>
      <el-option label="不是" value="0"></el-option>
    
    </el-select>
  </el-form-item>
  <el-form-item label="直营牵线">
    <el-select v-model="formInline.isPullStrings" placeholder="不限">
      <el-option label="是" value="1"></el-option>
      <el-option label="不是" value="0"></el-option>
    
    </el-select>
  </el-form-item>
  <el-form-item label="月收入">
    <el-select v-model="formInline.monthlyIncome" placeholder="不限">
      <el-option label="5千以下" value="1"></el-option>
      <el-option label="5千-1万" value="2"></el-option>
      <el-option label="1万-2万" value="3"></el-option>
      <el-option label="2万-3万" value="4"></el-option>
      <el-option label="3万-5万" value="5"></el-option>
      <el-option label="5万以上" value="6"></el-option>
     
    
    </el-select>
  </el-form-item>
  
  <el-form-item label="客户来源">
    <el-select v-model="formInline.source" placeholder="请选择">
    <el-option
      v-for="item in source"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
  </el-form-item>
  <el-form-item label="注册地区">
    <el-cascader
          v-model="formInline.registerAddress"
          :options="options123"
          @change="onChange"
          :props="{ checkStrictly: true }"
          clearable></el-cascader>
      </el-form-item>
      <el-form-item label="注册ip地区">
        <el-cascader
          v-model="formInline.registerIpAddress"
          :options="options1234123"
          @change="onChanges"
          :props="{ checkStrictly: true }"
          clearable></el-cascader>


</el-form-item>
<el-form-item label="申请牵线时间">
    <el-col :span="11">
      <el-date-picker  value-format="yyyy-MM-dd HH:mm:ss"    type="datetime" placeholder="选择日期" v-model="formInline.beginPullStringsApplyTime" style="width: 100%;"></el-date-picker>
    </el-col>
    <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
    <el-col :span="11">
      <el-date-picker   value-format="yyyy-MM-dd HH:mm:ss"     type="datetime" placeholder="选择日期" v-model="formInline.endPullStringsApplyTime" style="width: 100%;"></el-date-picker>

    </el-col>
  </el-form-item>
  <el-form-item label="注册时间">
    <el-col :span="11">
      <el-date-picker  value-format="yyyy-MM-dd HH:mm:ss"    type="datetime" placeholder="选择日期" v-model="formInline.beginRegisterTime" style="width: 100%;"></el-date-picker>
    </el-col>
    <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
    <el-col :span="11">
      <el-date-picker   value-format="yyyy-MM-dd HH:mm:ss"     type="datetime" placeholder="选择日期" v-model="formInline.endRegisterTime" style="width: 100%;"></el-date-picker>

    </el-col>
  </el-form-item>
  <el-form-item label="活跃时间">
    <el-col :span="11">
      <el-date-picker  value-format="yyyy-MM-dd HH:mm:ss"    type="datetime" placeholder="选择日期" v-model="formInline.beginLastActiveTime" style="width: 100%;"></el-date-picker>
    </el-col>
    <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
    <el-col :span="11">
      <el-date-picker   value-format="yyyy-MM-dd HH:mm:ss"     type="datetime" placeholder="选择日期" v-model="formInline.endLastActiveTime" style="width: 100%;"></el-date-picker>

    </el-col>
  </el-form-item>
 
  <el-form-item label="年龄">
    <el-col :span="4">
      <el-input size="small" clearable  v-model="formInline.beginAge" placeholder="不限"></el-input>
    </el-col>
    <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp; -</el-col>
    <el-col :span="4">
      <el-input size="small" clearable  v-model="formInline.endAge" placeholder="不限"></el-input>
    </el-col>
  </el-form-item>
  <el-form-item label="身高">
    <el-col :span="4">
      <el-input size="small" clearable  v-model="formInline.beginHeight" placeholder="不限"></el-input>
    </el-col>
    <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp; -</el-col>
    <el-col :span="4">
      <el-input size="small" clearable  v-model="formInline.endHeight" placeholder="不限"></el-input>
    </el-col>
  </el-form-item>
<el-form-item>
  <el-form-item label="颜值分数">
    <el-col :span="4">
      <el-input size="small" clearable  v-model="formInline.beginAppearanceScore" placeholder="不限"></el-input>
    </el-col>
    <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp; -</el-col>
    <el-col :span="4">
      <el-input size="small" clearable  v-model="formInline.endAppearanceScore" placeholder="不限"></el-input>
    </el-col>
  </el-form-item>


     

</el-form-item>
<div style=" float: right; margin-right: 50px; margin-bottom: 50px; ">
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button @click="resetForm('formInline')">重置</el-button>
       
        </div> 
    </el-form> 
  
    <!--列表-->
    <el-table id="educe-table" size="small" ref="multipleTable" stripe :data="listData" highlight-current-row v-loading="loading"
  
    @select-all="selectall"  @select="select" border element-loading-text="拼命加载中"  style="width: 100%;font-size: 18px;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column style="font-size: 22px;" sortable prop="id" label="UID" width="150">
        <template slot-scope="scope">
          <span style="font-size: 22px; color: #885DDF; ">{{  scope.row.id}}</span>
          <!-- <div>{{scope.row.editTime|timestampToTime}}</div> -->
        </template>
      </el-table-column>
      <el-table-column sortable prop="nickName"  label="昵称" width="200">

     <template slot-scope="scope">
      <span style="font-size: 20px;">{{ scope.row.nickName }}</span><br>
      <span style="color: #3399FF; font-size: 20px;" v-if="scope.row.nickNameStatus==1">(待审核)</span>
      <span style="color: #34D0B4; font-size: 20px;" v-if="scope.row.nickNameStatus==2">(审核通过)</span>
      <span style="color: #CF1F1F; font-size: 20px;" v-if="scope.row.nickNameStatus==3">(审核不通过)</span>
          <!-- <img style="width: 200px; height: 200px;" :src="scope.row.headIcon" alt=""> -->
          <!-- <div>{{scope.row.editTime|timestampToTime}}</div> -->
        </template>
      </el-table-column>
      <el-table-column sortable prop="headIcon" label="头像" width="220">

        <template slot-scope="scope">
          <el-image 
      style="width: 200px; height: 200px;"
      :src="scope.row.headIcon"
    @click="adder"
    :preview-src-list="[scope.row.headIcon]"/>

          <!-- <img style="width: 200px; height: 200px;" :src="scope.row.headIcon" alt=""> -->
          <span style="color: #3399FF; font-size: 20px;" v-if="scope.row.headIconStatus==1">(待审核)</span>
      <span style="color: #34D0B4; font-size: 20px;" v-if="scope.row.headIconStatus==2">(审核通过)</span>
      <span style="color: #CF1F1F; font-size: 20px;" v-if="scope.row.headIconStatus==3">(审核不通过)</span>

          <!-- <div>{{scope.row.editTime|timestampToTime}}</div> -->
        </template>
      </el-table-column>
      <el-table-column sortable prop="headIcon" label="基本信息" width="220">
        <template slot-scope="scope" >
          <span style="font-size: 18px;" >年龄:{{ scope.row.age }}/{{ scope.row.sex==1?"男":"女" }}</span></br>
          <div style="font-size: 18px;">学历:  <span v-if="scope.row.education==7">博士后</span>
          <span v-if="scope.row.education==6">博士</span>
          <span v-if="scope.row.education==5">硕士</span>
          <span v-if="scope.row.education==4">本科</span>
          <span v-if="scope.row.education==3">大专</span>
          <span v-if="scope.row.education==2">中专</span>
          <span v-if="scope.row.education==1">中专以下</span></div>
          <span style="font-size: 18px;" >身高:{{ scope.row.height}} {{scope.row.height?'cm': '' }}</span></br>
          <span style="font-size: 18px;" >月收入:{{ scope.row.monthlyIncomeDesc }}</span></br>
          <div style="font-size: 18px;" >婚姻状况:
          <span style="font-size: 18px;" v-if="scope.row.maritalStatus==1">未婚</span>
          <span style="font-size: 18px;" v-if="scope.row.maritalStatus==2">离异</span>
          <span style="font-size: 18px;" v-if="scope.row.maritalStatus==3">丧偶</span>
          </div></br>
         
         

          <!-- <img style="width: 200px; height: 200px;" :src="scope.row.headIcon" alt=""> -->
          <!-- <div>{{scope.row.editTime|timestampToTime}}</div> -->
        </template>
      </el-table-column>
      <el-table-column sortable prop="sex" label="地址" width="200">
        <template slot-scope="scope">
         <span style="font-size: 14px;">注册地址:{{scope.row.registerAddress }}</span><br>
         <span style="font-size: 14px;">注册ip地址:{{scope.row.registerIpAddress }}</span><br>
         <span style="font-size: 14px;">登录ip地址:{{scope.row.loginAddress }}</span><br>
          
        </template>
      </el-table-column>
      <el-table-column sortable prop="nickName" label="直营牵线" width="100">
        <template slot-scope="scope">
          <div style="font-size: 18px;">{{ 
            scope.row.isPullStrings==0?'否':"是"
             }}</div>
          <!-- <div v-if="scope.row.registerType==2">完成注册</div> -->
        </template>
        
      </el-table-column>
      <el-table-column sortable prop="age" label="牵线申请" width="200">
        <template slot-scope="scope">
          <div style="font-size: 14px">次数:{{ scope.row.pullStringsNum }}</div><br>
          <div style="font-size: 14px">时间:{{ scope.row.pullStringsApplyTime|timestampToTime }}</div>
          <!-- <div>{{scope.row.pullStringsApplyTime|timestampToTime}}</div> -->
        </template>
      </el-table-column>
      <el-table-column sortable prop="nickName" label="手机" width="100">
        <template slot-scope="scope">
          <div>{{ scope.row.phone }}</div>
          
        </template>
        
      </el-table-column>
      <el-table-column sortable prop="nickName" label="注册类型" width="100">
        <template slot-scope="scope">
          <div style="font-size: 14px">{{ scope.row.registerType==1?"小程序":""}}</div>
          
        </template>
        
      </el-table-column>
      <el-table-column sortable prop="sourceDesc" label="客户来源" width="100">
      </el-table-column>
      <el-table-column sortable prop="nickName" label="注册时间" width="100">
        <template slot-scope="scope">
          <div style="font-size: 14px">{{ scope.row.registerTime|timestampToTime }}</div>
          
        </template>
        
        

      </el-table-column>
      <el-table-column sortable prop="nickName" label="活跃时间" width="100">
        <template slot-scope="scope">
          <div style="font-size: 14px">{{ scope.row.registerTime|timestampToTime}}</div>
          
        </template>
        
      </el-table-column>
      <el-table-column sortable prop="version"  style="font-size: 14px" label="版本号" width="200"></el-table-column>
      
      
     
      
      <el-table-column   fixed="right" sortable prop="nickName" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="Clickbutton(scope.row.id)" type="primary">编辑</el-button>
          
        </template>
        
      </el-table-column>
  
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm"   style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"  @size-change="handleSizeChange" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <div style="margin-top: 20px;">
      <el-button @click="selectalls(listData)" type="primary">全选</el-button>
      <el-button @click="imporList" type="success">导出数据</el-button>
      <el-button @click="deledUser" type="danger">删除</el-button>

    </div>
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="部门名称" prop="deptName">
          <el-input size="small" v-model="editForm.deptName" auto-complete="off" placeholder="请输入部门名称"></el-input>
        </el-form-item>
        <el-form-item label="部门代码" prop="deptNo">
          <el-input size="small" v-model="editForm.deptNo" auto-complete="off" placeholder="请输入部门代码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
  title="提示"
  :visible.sync="dialogVisible"
  width="30%"
  >
  <span>确定导出用户数据？</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisibles">确 定</el-button>
  </span>
</el-dialog>
<el-dialog
  title="提示"
  :visible.sync="delleVisible"
  width="30%"
  >
  <span>确定要删除吗？一旦执行不可恢复！</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="delleVisible = false">取 消</el-button>
    <el-button type="primary" @click="deleLVisibles">确 定</el-button>
  </span>
</el-dialog>


  </div>
</template>

<script>
import { deptList, deptSave,deptDelete} from '../../api/userMG'
import Axios from 'axios'
import { login } from "../../api"


import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      dialogVisible: false,
      delleVisible:false,
      options1234123:[],
      options123:[],
      ids:"",
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      options: [{
          value: 1,
          label: '中专以下'
        }, {
          value: 2,
          label: '中专'
        }, {
          value: 3,
          label: '大专'
        }, {
          value: 4,
          label: '本科'
        }, {
          value: 5,
          label: '硕士'
        },{
          value: 6,
          label: '博士后'
        },{
          value: 7,
          label: '博士后'
        }],
        source:[{
          value: 1,
          label: '网站注册'

        },{
          value: 2,
          label: '人工录入'

        },{
          value: 3,
          label: '资源导入'

        },{
          value: 4,
          label: '相亲活动'

        },{
          value: 5,
          label: '手机来电'

        },{
          value: 6,
          label: '表单填写'

        },{
          value: 7,
          label: '到店咨询'

        }],
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      importList:[],
      adder:"",
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        endRegisterTime:"",
        registerAddress:'',
        version:"",
        education:"",   
        registerIpAddress:"",
        beginRegisterTime:"",
        searchType:"",
        source:"",
        endRegisterTime:"",//结束注册使劲
        beginRegisterTime:"",//开始注册时间
        monthlyIncome:"",//月收入
        accountId:"",
        beginLastActiveTime:"",//开始活跃时间
        endLastActiveTime:"",//结束活跃时间
        isTestAccount:"",//是否测试号
        beginPullStringsApplyTime:"",//开始牵线时间
        endPullStringsApplyTime:"",//结束牵线时间
        isPullStrings:"",//直营牵线
        nickNameStatus:"",//昵称审核
        headIconStatus:"",//头像审核
          sex:'',
          endAppearanceScore:"",//结束颜值分数
          beginAppearanceScore:"",//开始颜值分数
        nickName:"",
        searchType:2,
        beginHeight:'',
        endHeight:"",
        maritalStatus:"",//婚姻状况
        phone:"",
        beginAge:"",
        endAge:"",
        current: 1,
        size: 10,
        // token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    let tokenId= localStorage.getItem('tokenId');
    this.adder =tokenId

    // this.getdata(this.formInline)
  },
   mounted(){
    this.formLIst()
    this.getAddress()
    this.getAddresss()

   
   },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 删除用户数据
    deledUser(){
     this.delleVisible=true
    },
    deleLVisibles(){



      Axios({
  method: 'post',

  url: 'https://platform-test.ynhlminiapp.com/api/platform-account/delete',
  data: {
    accountIds: this.importList
  },
  headers:{
    tokenId:this.adder
        },

}).then(res => {
  if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
  console.log(res);
  if(res.data.code==0){
    this.delleVisible=false
    this.$message({
          message: '删除成功',
          type: 'success'
        });
        this.formLIst()
  }
})


      
    },
    Clickbutton(id){
      console.log(111);
      this.$router.push({
    path:"/goods/userGoods",
    query:{ //query是个配置项
        id:id
    }
})

    },
    getAddress(){
      Axios({
        method: 'get',
        url: 'https://platform-test.ynhlminiapp.com/api/common/getAddressList1',
        headers:{
    tokenId:this.adder
        },
      }).then(res => {
        // console.log("getAddressList", res.data.data);
        this.options123 = res.data.data

      })
    },
    getAddresss(){
      Axios({
        method: 'get',
        url: 'https://platform-test.ynhlminiapp.com/api/common/getAddressList1',
        headers:{
    tokenId:this.adder
        },
      }).then(res => {
        // console.log("getAddressList", res.data.data);
        this.options1234123 = res.data.data

      })
    },
   
    change1(e){
      console.log("change1", e);
      if(e.length === 1){
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if(e.length === 2){
        this.formInline.registerAddress=e[1];
      }
    },
    onChange(e){
              
              this.formInline.registerAddress=e[1]
                // console.log( this.formInline.registerAddress);
              

            },
            onChanges(e){
              this.formInline.registerIpAddress=e[1]
                // console.log( this.formInline.registerAddress);
            },
    // checkChange(a,b){
    //   console.log(a,b);

    // },

    selectalls(rows){
      // console.log(row);
              //  return console.log("rows : "+JSON.stringify(rows));
                if(rows){
                  rows.forEach(row =>{
                    this.$refs.multipleTable.toggleRowSelection(row);
                  });
                }else{
                    this.$refs.multipleTable.clearSelection();//清除全选
                }
              },


   
    selectall(val){
      
      let data =[]
      // this.importList=''
      val.forEach((item)=>{
        data.push(item.id)
        this.importList =data
        console.log(this.importList);

      })

    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    // 导出数据

    select(selection, row){
      let data =[]
      // this.importList=''
      selection.forEach((item)=>{
        data.push(item.id)
        this.importList =data
        // console.log(this.importList);

      })
      
      

    },

    imporList(){
      if(this.importList.length==0){
       
        this.$message({
          type: 'warning',
          message: '请选择要导出的数据'
        })
        return
     
      }else{
        this.dialogVisible=true
  


      }
     



    },
    dialogVisibles(){
      Axios({
  method: 'post',

  url: 'https://platform-test.ynhlminiapp.com/api/platform-account/exportExcel',
  headers:{
    tokenId:this.adder
        },
  data: {
    accountIds: this.importList
  },
  responseType: 'blob'
}).then(res => {
  if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
  const link = document.createElement('a') // 创建a标签
  const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
  link.href = window.URL.createObjectURL(blob)
  const filename = res.headers['content-disposition'].split('filename=')[1]
  link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
  link.click()
  window.URL.revokeObjectURL(link.href)
})
this.dialogVisible=false
    },
    
    resetForm(formInline) {
  //  this.formInline =''
        this.$refs[formInline].resetFields();
      },


    formLIst(){
      // let accountListReqVO= this.formInline
      Axios({
  method: 'get',

  url: 'https://platform-test.ynhlminiapp.com/api/platform-account/accountList',
  headers:{
    tokenId:this.adder
        },
  params:this.formInline
    // current: this.formInline.current,
    // size: this.formInline.size,
    // accountListReqVO
  
    
    

}).then(res=>{
  if(res.data.code==999){
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
  this.listData =res.data.data.list

      this.pageparm.currentPage = this.formInline.current
      this.pageparm.pageSize = this.formInline.size
      this.pageparm.total = res.data.data.total
  console.log(res);
})

    },
    formatData(row, column, cellValue, index){
		
		//把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
		//最终返回 s 就可以了
		var s =	new Date(cellValue).toLocaleString();
	    return s;

		  // 测试参数含义：不知道参数是什么含义的就打印出来
		  // console.log(row)     	//拿到一行的所有信息，要拿到具体信息,只需要row.XXX 就可以了
		  // console.log(column)  	//拿到列的信息
		  // console.log(cellValue) //拿到单元格数据，拿到时间 2022-03-18T01:46:08.000+00:00
		  // console.log(index)     //拿到索引
	    },

    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        count: 5,
        data: [
          {
            addUser: null,
            editUser: null,
            addTime: 1521062371000,
            editTime: 1526700200000,
            deptId: 2,
            deptName: 'XX分公司',
            deptNo: '1',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1521063247000,
            editTime: 1526652291000,
            deptId: 3,
            deptName: '上海测试',
            deptNo: '02',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526349555000,
            editTime: 1526349565000,
            deptId: 12,
            deptName: '1',
            deptNo: '11',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526373178000,
            editTime: 1526373178000,
            deptId: 13,
            deptName: '5',
            deptNo: '5',
            parentId: 1
          },
          {
            addUser: null,
            editUser: null,
            addTime: 1526453107000,
            editTime: 1526453107000,
            deptId: 17,
            deptName: 'v',
            deptNo: 'v',
            parentId: 1
          }
        ]
      }
      this.loading = false
      
      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      deptList(parameter)
        // .then(res => {
        //   console.log(res);
        //   this.loading = false
        //   if (res.success == false) {
        //     this.$message({
        //       type: 'info',
        //       message: res.msg
        //     })
        //   } else {
        //     this.listData = res.data
        //     // 分页赋值
        //     this.pageparm.currentPage = this.formInline.current
        //     this.pageparm.pageSize = this.formInline.size
        //     this.pageparm.total = res.count
        //   }
        // })
        // .catch(err => {
        //   this.loading = false
        //   this.$message.error('菜单加载失败，请稍后再试！')
        // })
    },
    handleSizeChange(e){
      // reru console.log(e.pageSize);
      this.formInline.size =e.pageSize
      this.formInline.current = e.currentPage
      
      this.formLIst()
    // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
this.formLIst()
      
      // console.log(this.formInline);
      // this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          deptSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('公司保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // async logins() {
    //     // 网络请求
    //     let data = await login('1111111');
    //     // let token = data.token;
    //     // 本地  vuex
    //     // this.$store.commit('LOGIN_IN',token);
    //     this.$router.replace("/")
    // },

    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/pay/Order.vue